(function () {
  if (customElements.get('gift-sync')) return;
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var KEY = 'co_hw_gift';
  var busy = false;
  var tries = 0;
  var onCart = /^\/cart\/?$/.test(window.location.pathname);

  function getFlag() { try { return window.localStorage.getItem(KEY); } catch (e) { return window.__coHwGift || null; } }
  function setFlag(v) {
    try { if (v) window.localStorage.setItem(KEY, v); else window.localStorage.removeItem(KEY); } catch (e) { window.__coHwGift = v || null; }
  }

  function parse(html, selector) {
    var node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : null;
  }

  function render(sections) {
    if (!sections) return;
    var drawer = document.getElementById('CartDrawer');
    if (drawer && sections['cart-drawer']) {
      var inner = parse(sections['cart-drawer'], '#CartDrawer');
      if (inner !== null) {
        drawer.innerHTML = inner;
        var host = document.querySelector('cart-drawer');
        var overlay = document.getElementById('CartDrawer-Overlay');
        if (host && overlay && typeof host.close === 'function') {
          overlay.addEventListener('click', host.close.bind(host));
        }
      }
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var b = parse(sections['cart-icon-bubble'], '.shopify-section');
      if (b !== null) bubble.innerHTML = b;
    }
  }

  function req(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function post(url, payload) {
    busy = true;
    if (!onCart) {
      payload.sections = SECTIONS;
      payload.sections_url = window.location.pathname;
    }
    return req(url, payload)
      .then(function (j) {
        if (onCart) { window.location.reload(); }
        else if (j && j.sections) { render(j.sections); }
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function giftItem(vid) {
    return { items: [{ id: vid, quantity: 1, properties: { _free_gift: 'halloween' } }] };
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-gift-pick]') : null;
    if (!btn || busy) return;
    e.preventDefault();
    if (btn.classList.contains('is-selected')) return;
    var vid = Number(btn.getAttribute('data-variant'));
    var sync = document.querySelector('gift-sync');
    var flagKey = sync ? sync.getAttribute('data-flag-key') : '';
    btn.disabled = true;
    setFlag('added');
    if (flagKey) {
      busy = true;
      req('/cart/change.js', { id: flagKey, quantity: 0 })
        .catch(function () {})
        .then(function () { busy = false; return post('/cart/add.js', giftItem(vid)); });
    } else {
      post('/cart/add.js', giftItem(vid));
    }
  });

  class GiftSync extends HTMLElement {
    connectedCallback() {
      if (this.getAttribute('data-auto') !== 'true' || busy) return;
      var qualifies = this.getAttribute('data-qualifies') === 'true';
      var flagKey = this.getAttribute('data-flag-key');
      var inCart = this.getAttribute('data-in-cart') === 'true';
      var paid = this.getAttribute('data-paid') === 'true';
      var def = Number(this.getAttribute('data-default')) || 0;

      if (!qualifies) {
        setFlag(null);
        if (flagKey && tries++ < 3) post('/cart/change.js', { id: flagKey, quantity: 0 });
        return;
      }
      // Safety: never leave a gift line that is still being charged.
      if (flagKey && paid) {
        setFlag('declined');
        if (tries++ < 3) post('/cart/change.js', { id: flagKey, quantity: 0 });
        return;
      }
      tries = 0;
      var flag = getFlag();
      if (!inCart && def && flag !== 'added' && flag !== 'declined') {
        setFlag('added');
        post('/cart/add.js', giftItem(def));
      }
    }
  }

  customElements.define('gift-sync', GiftSync);
})();
